/* @flow */

import * as React from 'react';

import {HelpButton} from '../help';
import {Popover} from '../popover';

import './popover-info.css';

type Props = {
    info: string | React.Node,
    size?: number,
    isError?: boolean,
    bodyColor?: 'light' | 'dark' | 'error',
};

PopoverInfo.defaultProps = {
    bodyColor: 'light',
};

export function PopoverInfo(props: Props) {
    const [isPopoverShown, setIsPopoverShown] = React.useState<boolean>(false);
    const [iconRef, setIconRef] = React.useState<?HTMLElement>(null);

    const {info, ...restProps} = props;

    return (
        <>
            <HelpButton
                ref={(ref) => {
                    setIconRef(ref);
                }}
                size={props.size}
                isError={props.isError}
                onClick={() => {
                    setIsPopoverShown(true);
                }}
            />
            {isPopoverShown ? (
                <Popover
                    {...restProps}
                    anchor={iconRef}
                    onBlur={() => {
                        setIsPopoverShown(false);
                    }}
                    bodyColor={props.bodyColor}
                >
                    <div className='pad-16' styleName='popover-text'>
                        {info}
                    </div>
                </Popover>
            ) : (
                undefined
            )}
        </>
    );
}
